import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Input, Select, Checkbox } from 'components/fields'
import { Module } from 'components/misc'

import { selectMap } from 'redux/selectors/misc'

export default class ParticipantOther extends PureComponent {
  static propTypes = {
    genders: PropTypes.array,
    nationalities: PropTypes.array,
    employmentStatuses: PropTypes.array,
    levels: PropTypes.array,
    showNationality: PropTypes.bool,
    showEmploymentStatus: PropTypes.bool
  }

  static defaultProps = {
    levels: []
  }

  render() {
    const { genders, nationalities, employmentStatuses, levels,
      showNationality, showEmploymentStatus } = this.props

    return (
      <Module title="Other info" intlKey="moduleTitle.other_info" narrow>
        {showNationality && <div className="row">
          <div className="col-xs-6">
            <Select
              label="Nationality"
              intlKey="label.nationality"
              name="nationality.value"
              options={nationalities}
              searchable
            />
          </div>
        </div>}

        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Gender"
              intlKey="label.gender"
              name="gender.value"
              options={genders}
            />
          </div>
        </div>

        {showEmploymentStatus && <div className="row">
          <div className="col-xs-6">
            <Select
              label="Employment status"
              intlKey="label.employement_status"
              name="employmentStatus.value"
              options={employmentStatuses}
            />
          </div>
        </div>}

        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Previous level (not ORB)"
              intlKey="label.previous_completed_award_level"
              name="participantDetail.previousCompletedAwardLevel.value"
              options={selectMap(levels)}
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="Where"
              intlKey="label.previous_completed_award_place"
              name="participantDetail.previousCompletedAwardPlace"
            />
          </div>
        </div>

        <Checkbox
          label="Participant agrees that we can use his/her profile picture for promotion"
          intlKey="label.photo_consent_given"
          name="participantDetail.isGivenConsentForPhotoUse"
        />
      </Module>
    )
  }
}
